import React, { useState } from 'react'
import api from '../services/api'
import { getUserCredits } from '../helpers/Users'
import UserByTag from '../components/Users/UserByTag'
import Modal from '../components/Modal'

export default function Saida() {
  const [userCredit, setUserCreddit] = useState({})
  const [comanda, setComanda] = useState('')
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showError, setShowError] = useState(false)
  const [showNotFound, setShowNotFound] = useState(false)
  const [modal, setModal] = useState({})
  const [response, setResponse] = useState([])


  async function confirmExit() {

    try {
      setModal({
        show: true,
        type: 'warning',
        title: 'Desassociado com Sucesso',
        msg: 'Trabalhando em sua operação',
        loading: true
      })
      const res = await api.delete('/credit/batch', {data: {tags: comanda.trim()}} )
      setComanda("")
      setResponse(res.data)
      setModal({
        show: false,
      })
    } catch (e) {

      setModal({
        show: true,
        type: 'danger',
        title: 'Falhamos',
        msg: e.response.data.error,
        link: '/'
      })
    }
  }

  return (
    <div>
      <Modal modal={modal} />
      <h1>Saída</h1>
      <p>Você está na página para dar baixas nas comandas</p>
      <div className="container mt-5">
        <h3>Comanda</h3>
        <p>Digite as comandas separadas por virgula</p>
        <div className="mb-3 text-center">
          <label htmlFor="codigo" className="form-label"></label>
          <input
            type="text"
            className={`form-control ${comanda.length > 0 ? 'is-valid' : 'is-invalid'}`}
            id="codigo"
            value={comanda}
            onChange={(e) => setComanda(e.target.value)}
          />
          <div className="my-5">
            {comanda.split(",").map(c => c.trim()).filter(c => c).length > 0 && (

              <div className="d-flex flex-column align-items-start">
                {[...new Set(comanda.split(",").map(c => c.trim()).filter(c => c))].map((item, index) => (
                  <div key={index} className="d-flex align-items-center mb-2">
                    <span className="me-2 fw-bold">{index + 1}.</span>
                    <UserByTag tag={item} />
                  </div>
                ))}
              </div>

            )}

          </div>
          <button
            className="mt-5 btn btn-warning"
            onClick={confirmExit}
            disabled={comanda.split(",").map(c => c.trim()).filter(c => c).length === 0}
          >
            Confirmar saída
          </button>
        </div>

        <div className="text-center">
          {response.length > 0 && (
            <div>
              {response.map((item, index) => (
                <div
                  key={index}
                  className={`alert ${item.msg.toLowerCase().includes('error') ? 'alert-warning' : 'alert-success'}`}
                  role="alert"
                >
                  {item.msg.toLowerCase().includes('error') ? (
                    <>Comanda já desassociada - {item.tag}</>
                  ): (
                    <>Sucesso em desassociar a comanda {item.tag}</>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
